import React, { createContext, useContext, useMemo } from "react";
import { useSessionStorage } from "utils";

const PublisherThemeConfigContext = createContext();

export const PublisherThemeConfigProvider = ({ children }) => {
  const [themeConfigFromSessionStorage] = useSessionStorage("tilia.ac.theme");
  const themeConfig = useMemo(() => {
    return themeConfigFromSessionStorage ? JSON.parse(themeConfigFromSessionStorage) : {};
  }, [themeConfigFromSessionStorage]);
  return (
    <PublisherThemeConfigContext.Provider value={{ themeConfig }}>
      {children}
    </PublisherThemeConfigContext.Provider>
  );
};

export const usePublisherThemeConfig = () => useContext(PublisherThemeConfigContext);
